// app/src/components/SignUpPageDesktopPartPanel2.tsx

import React, { FC } from 'react';
import { useTranslation } from "react-i18next";

interface SignUpPageDesktopPartPanel2Props {
	isOpen: boolean;
	setIsOpen: (open: boolean) => void;
}

const SignUpPageDesktopPartPanel2: FC<SignUpPageDesktopPartPanel2Props> = ({
	isOpen,
	setIsOpen,
}) => {
	const { t } = useTranslation();
	
	const truncatedText = t('signupPanelPart:truncatedText');
	const fullText = t('signupPanelPart:fullText');
	
	return (
		<div
			style={{
				marginTop: 20,
				width: 1601,
				height: isOpen ? 'auto' : 30,
				background: '#FFFFFF',
				borderRadius: 20,
				position: 'relative',
				padding: 24,
				boxShadow: '0px 1px 6px #00000029',
				transition: 'height 0.3s ease',
			}}
		>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					cursor: 'pointer',
					position: 'relative',
				}}
				onClick={() => setIsOpen(!isOpen)}
			>
				<div
					style={{
						width: '95%'
					}}
				>
					{isOpen && (
						<div
							style={{
								marginTop: 3,
								fontSize: 16,
								color: '#323E48',
								lineHeight: '1.5',
								whiteSpace: 'pre-wrap',
							}}
						>
							{fullText}
						</div>
					)}
					{!isOpen && (
						<div
							style={{
								marginTop: 3,
								fontSize: 16,
								color: '#323E48',
								lineHeight: '1.5',
								whiteSpace: 'pre-wrap',
							}}
						>
							{truncatedText}
						</div>
					)}
				</div>
				<div
					style={{
						position: 'absolute',
						right: 0,
						top: 0,
					}}
				>
					{isOpen ? (
						<img
							src="/images/chevron-down.svg"
							alt="chevron-down"
							style={{ width: 20, height: 20 }}
						/>
					) : (
						<img
							src="/images/chevron-right.svg"
							alt="chevron-right"
							style={{ width: 24, height: 24 }}
						/>
					)}
				</div>
			</div>
		</div>
	);
};

export default SignUpPageDesktopPartPanel2;
